import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import viewerReducer from "./viewer";
import captchaReducer from "./captcha";
import locationReducer from "./location";
import platformReducer from "./platform";
import modalsReducer from "./modals";
import formReducer from "./form";
import errorBoundariesReducer from "./errorBoundaries";
import resourcesListReducer from "./resourcesList";
import contributionsConnectionsReducer from "./contributionsConnections";
import alertsReducer from "./alerts";
import stylingReducer from "./styling";
import wysiwygReducer from "./wysiwyg";
import mapReducer from "./map";
import draggingReducer from "./dragging";

const persistedLocationReducer = persistReducer(
  {
    storage,
    key: "location",
    whitelist: ["storedLocation"]
  },
  locationReducer
);

export default combineReducers({
  viewer: viewerReducer,
  captcha: captchaReducer,
  location: persistedLocationReducer,
  platform: platformReducer,
  modals: modalsReducer,
  forms: formReducer,
  errorBoundaries: errorBoundariesReducer,
  resourcesList: resourcesListReducer,
  contributionsConnections: contributionsConnectionsReducer,
  alert: alertsReducer,
  styling: stylingReducer,
  map: mapReducer,
  wysiwyg: wysiwygReducer,
  dragging: draggingReducer
});
